import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./Profile.css";
import Step0 from "./Steps/Step0";
import Step1 from "./Steps/Step1";
import Step2 from "./Steps/Step2";
import Step3 from "./Steps/Step3";
import Step4 from "./Steps/Step4";
import Step5 from "./Steps/Step5";
import Step6 from "./Steps/Step6";
import Step7 from "./Steps/Step7";
import ProgressBar from "./ProgressBar"; // Import the progress bar component

import { useLocation, useNavigate } from "react-router-dom";
import {
  saveProfile,
  submitProfile,
  setSuccess,
  initInformation,
} from "../../store/setProfile";
import SweetAlert from "sweetalert2";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import errorIcon from "../../assets/error-icon.svg";
import { selectIsDraftDirty } from "../../store/setProfile/selectors";
import { toast } from "react-toastify";

const stripePublicKey = process.env.REACT_APP_STRIPE_PUBLIC_KEY;
const stripePromise = loadStripe(stripePublicKey); // Replace with your actual Stripe publishable key

const Profile = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const queryParams = new URLSearchParams(location.search);

  const parsedStep = parseInt(queryParams.get("step") || 0);
  const step = Number.isNaN(parsedStep)
    ? 0
    : Math.min(Math.max(parsedStep, 0), 6);
  const level = useSelector((state) => state.profile.information.level);

  const goToStep = (newStep) => {
    const queryParams = new URLSearchParams(location.search);
    queryParams.set("step", newStep);
    navigate(`${location.pathname}?${queryParams.toString()}`);
  };

  const nextStep = () => {
    if (step === 6) return;
    goToStep(step + 1);
  };

  const backStep = () => {
    if (step === 0) return;
    goToStep(step - 1);
  };

  const { information, success, message } = useSelector(
    (state) => state.profile
  );
  const isDirty = useSelector(selectIsDraftDirty);

  const save = () => {
    if (!isDirty) {
      nextStep();
      return;
    }
    dispatch(saveProfile({ information, setLoading, nextStep }));
  };
  const submit = () => {
    dispatch(submitProfile({ information, setLoading, navigate }));
  };

  useEffect(() => {
    if (success > 0) {
      dispatch(setSuccess({ success: 0, message: "" }));
      return;
    }
    if (success < 0) {
      SweetAlert.fire({
        imageUrl: errorIcon,
        imageHeight: "100px",
        title: "Oops...",
        text:
          message.length > 0
            ? message
            : "Can't connect with server, Please try again",
        confirmButtonColor: "#712d94",
      });
      dispatch(setSuccess({ success: 0, message: "" }));
    }
  }, [success, message, navigate, dispatch]);

  const profileContents =
    step === 0 ? (
      <Step0 save={save} loading={loading} isDirty={isDirty} />
    ) : step === 1 ? (
      <Step2 goBack={backStep} save={save} loading={loading} isDirty={isDirty} />
    ) : step === 2 ? (
      <Step4 goBack={backStep} save={save} loading={loading} isDirty={isDirty} />
    ) : step === 3 ? (
      <Step5 goBack={backStep} save={save} loading={loading} isDirty={isDirty} />
    ) : step === 4 ? (
        <Step6 goBack={backStep} save={save} loading={loading} isDirty={isDirty} />
    ) : step === 5 ? (
        <Elements stripe={stripePromise}>
          <Step3 goBack={backStep} save={save} loading={loading} isDirty={isDirty} />
        </Elements>
    ) : step === 6 ? (
      <Step7 goBack={backStep} save={save} loading={loading} submit={submit} isDirty={isDirty} />
    ) : (
      <p>No Step</p>
    );

  useEffect(() => {
    dispatch(setSuccess({ success: 0, message: "" }));
    return () => {
      dispatch(initInformation());
    };
  }, [dispatch]);

  return (
    <div className="profile-container">
      {/* Add the progress bar */}
      <ProgressBar step={step} />

      {profileContents}
    </div>
  );
};

export default Profile;
